import RfidCreateContainer from "./RfidCreateContainer"


const RfidCardCreate = () => {
  return (
    <div className='page-body'>
      <RfidCreateContainer />
    </div>
  )
}

export default RfidCardCreate